/*
 * Project: BookingEngine
 * Module: components/booking/extras/ExtraTransfer.js
 * vim:ft=javascript.jsx:
 */

import '../../../static/less/global/customAnimations.less';

import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import formatCurrency from 'format-currency';
import PictureSlider from '../rooms/PictureSlider';
import { getLangValue } from '../../../utils/Generic';
import PaxSelector from './PaxSelector';
import CalendarSelector from '../../common/CalendarSelector';
import TimePicker from '../../common/TimePicker';
import QuantitySelector from '../../common/QuantitySelector';
import { addSelectedExtrasToCart } from '../../../actions/Cart';
import { removeFreeModeExtra } from '../../../actions/FreeModeCart';
import Btn from '../../ds/atoms/btn/base';
import { EXTRA_OPTIONAL_FIELDS } from '../../../constants';
import { DEVICES } from '../../../actions/Booking';
import { LOYALTY_STATUS } from '../../../actions/Loyalty';

const DATE_MASK = 'YYYY-MM-DD';
const DATE_MASK_PRINT = 'DD/MM/YYYY';

class ExtraCard extends React.Component {
  constructor(props) {
    super(props);

    const roomUse = props.cart.cartHotel.rooms[props.roomId - 1].use_alt;
    const specialInputFields = props.extra.type.map((type) => type.type_extra.toLowerCase());

    this.state = {
      animateRoom: false,
      isSelectedExtra: false,
      selectedTime: {
        hour: { name: '10', code: '10' },
        minute: { name: '00', code: '00' },
        timeFormat: { name: 'pm', code: 'pm' },
      },
      dateSelected: moment(props.checkIn),
      paxSelected: {
        adults: roomUse.adults,
        childs: roomUse.children,
        infants: roomUse.infants,
      },
      quantity: 1,
      guests: roomUse.adults + roomUse.children + roomUse.infants,
      rooms: props.cart.cartHotel.rooms,
      datePicker: specialInputFields.includes(EXTRA_OPTIONAL_FIELDS.DATEPICKER),
      quantitySelector: specialInputFields.includes(EXTRA_OPTIONAL_FIELDS.QUANTITYSELECTOR),
      timePicker: specialInputFields.includes(EXTRA_OPTIONAL_FIELDS.TIMEPICKER),
      paxSelector: specialInputFields.includes(EXTRA_OPTIONAL_FIELDS.PAXSELECTOR),
    };
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onDateChanged = this.onDateChanged.bind(this);
    this.paxUpdated = this.paxUpdated.bind(this);
    this.quantityUpdated = this.quantityUpdated.bind(this);
    this.renderSelectButton = this.renderSelectButton.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidUpdate() {
    if (this.state.isSelectedExtra) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isSelectedExtra: false });
    }
  }

  isAdded() {
    const { extra, cart, roomId } = this.props;
    return cart.cartHotel.rooms[roomId - 1].extras.some(
      (extraAdded) => extraAdded.code === extra.extra_code,
    );
  }

  formatDaysParam() {
    const { dateSelected } = this.state;
    const arrayDate = [];
    if (dateSelected) {
      arrayDate.push(dateSelected.format(DATE_MASK));
      return arrayDate;
    }
    return null;
  }

  formExtraFields() {
    const {
      paxSelected,
      selectedTime,
      dateSelected,
      quantity,
    } = this.state;

    const paxselector = {
      adults: paxSelected.adults,
      children: paxSelected.childs,
      infants: paxSelected.infants,
    };

    const { hour, minute, timeFormat } = selectedTime;
    // eslint-disable-next-line radix
    const timepicker = `${hour.code}:${minute.code} ${timeFormat.code}`;
    const datepicker = dateSelected.format(DATE_MASK);
    const quantityselector = quantity;
    return {
      ...(this.state.paxSelector && { paxselector }),
      ...(this.state.timePicker && { timepicker }),
      ...(this.state.datePicker && { datepicker }),
      ...(this.state.quantitySelector && { quantityselector }),
    };
  }

  truncate(input, len) {
    return input && input.length > len ? `${input.substring(0, len)}...` : input;
  }

  getExtraName(extra) {
    const extraName = getLangValue(extra, this.props.lang, 'title');
    return this.truncate(extraName, 40).toLowerCase();
  }

  paxUpdated(key, value) {
    const { paxSelected } = this.state;
    paxSelected[key] = value;
    const guests = paxSelected.adults + paxSelected.childs + paxSelected.infants;
    this.setState({ paxSelected, guests });
  }

  quantityUpdated(delta) {
    this.setState((prevState) => ({
      quantity: prevState.quantity + delta,
    }));
  }

  onChangeSelect(selectName, selectItem) {
    const { selectedTime } = this.state;
    selectedTime[selectName] = selectItem;
    this.setState({
      selectedTime,
    });
  }

  onDateChanged(date) {
    this.setState({
      dateSelected: date,
    });
  }

  getTime(oneWay) {
    const { selectedTime } = oneWay;
    return `${selectedTime.hour.name}:${selectedTime.minute.name} ${selectedTime.timeFormat.name}`;
  }

  formatDate(date) {
    return date ? moment(date).format(DATE_MASK_PRINT) : ' - ';
  }

  deleteExtra() {
    const { cart, extra, roomId } = this.props;
    const extraToDelete = cart.cartHotel.rooms[roomId - 1].extras.find((ext) => ext.code === extra.extra_code);
    const data = {
      roomCartId: cart.cartHotel.rooms[roomId - 1].unique_id,
      extraUuId: extraToDelete.extra_uuid,
    };
    this.setState({ isSelectedExtra: true });
    this.props.dispatch(removeFreeModeExtra(data));
  }

  openModal(e, extra) {
    e.preventDefault();
    this.props.openInfoModal(extra);
  }

  renderExtraTitle(extra) {
    const { currency } = this.props;

    let currentAmount = extra.prices ? extra.prices[currency.code].amount : 0;
    if (this.state.paxSelector) {
      currentAmount *= this.state.guests;
    }
    if (this.state.quantitySelector) {
      currentAmount *= this.state.quantity;
    }
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const minimumFractionDigits = 0;
    const maximumFractionDigits = 0;

    return (
      <div className="">
        <div className="extra-info__title text-capitalize" style={{ marginBottom: '10px' }}>
          {this.getExtraName(extra)}
        </div>
        <span className="amount-price__currency priceExtra">
          {extra.prices && formatCurrency(currentAmount, { ...currency, minimumFractionDigits, maximumFractionDigits })}
          <br/>
          {this.renderExtraDuration(extra)}
        </span>
      </div>
    );
  }

  renderExtraDuration(extra) {
    if (extra.duration === 0) {
      return null;
    }
    return (
      <div className="flex justify-between">
        <div className="extra-info__title text-capitalize">

        </div>
        <span className="extra-info__duration">
          <b>{this.context.t('Duration')}: {extra.duration} {this.context.t('hrs')}</b>
        </span>
      </div>
    );
  }

  renderExtraContent(extra) {
    const { isMobile } = this.props;
    const textLength = isMobile ? 176 : 185;
    return (
      <div className="extra-info mt-3 text-sm" style={{ lineHeight: '1.5' }}>
        {this.truncate(getLangValue(extra, this.props.lang, 'description'), textLength)}
      </div>
    );
  }

  renderExtraFields(extra) {
    const {
      checkIn,
    } = this.props.cart.cartHotel.rooms[this.props.roomId - 1];
    return (
      <div className="extra-info flex flex-col content-end justify-end">
        <div className='flex flex-row flex-nowrap justify-between'>
          {this.state.datePicker
            && (<CalendarSelector
              idDatePicker={extra.extra_code}
              hotelCode={this.props.cart.cartHotel.code}
              checkIn={checkIn}
              dateSelected={this.state.dateSelected}
              onChange={this.onDateChanged}
            />)}
          {this.state.timePicker
            && (<TimePicker
              className='flex items-center'
              selectedTime={this.state.selectedTime}
              onChange={this.onChangeSelect}
              hasBorder={false}
            />)}
        </div>
        {this.state.paxSelector
          && (<PaxSelector
            extra={extra}
            currentPax={this.state.paxSelected}
            paxUpdated={this.paxUpdated}
            hasTitle={false}
          />)}
        {this.state.quantitySelector
          && (<QuantitySelector
            label={getLangValue(extra, this.props.lang, 'quantity_label')}
            maxQuantity={extra.max_quantity}
            quantityNum={this.state.quantity}
            quantityUpdated={this.quantityUpdated}
            hasTitle={false}
          />)}
      </div>
    );
  }

  renderSelectButton(extra) {
    // For the buttons of the rooms that are not selected, we highlight them with a special style
    const { isCartUpdating } = this.props;
    const { paxSelected, paxSelector } = this.state;
    const isSelectedOne = isCartUpdating && this.state.isSelectedExtra;
    const hasAllPax = paxSelector && paxSelected.childs > 0 && paxSelected.infants > 0;
    const colOrRow = extra.type.length > 1 || hasAllPax;
    const isAdded = this.isAdded();
    return (
      <div className={`flex flex-wrap flex-row content-end ${colOrRow && 'w-full xl:w-auto xl:flex-col justify-end'}`}>
        <Btn
          className={`btn btn-primary p-3 uppercase self-start mr-2 ${colOrRow && 'mt-2 xl:mt-0 mb-0 xl:mb-2 xl:mr-0'}`}
          disabled={isCartUpdating}
          onClick={(e) => this.openModal(e, extra)}>{this.context.t('+ Info')}</Btn>
        {!isAdded ? (
          <button className={`btn btn-primary p-3 uppercase self-start add-card ${colOrRow ? 'mt-2' : ''}`}
            type='submit' disabled={isCartUpdating}>
            {isSelectedOne ? this.context.t('Adding') : this.context.t('Add')}
          </button>
        ) : (
          <Btn
            className={`btn btn-primary p-3 uppercase self-start justify-center edit-card ${colOrRow
              ? 'mt-2' : ''}`}
            disabled={isCartUpdating}
            onClick={() => this.deleteExtra()}>{isSelectedOne ? this.context.t('Editing') : this.context.t('Edit')}</Btn>
        )}
      </div>
    );
  }

  formSubmit = (e) => {
    e.preventDefault();
    const { extra, availId, roomId } = this.props;
    const { selectedStatus, memberInfo } = this.props.loyalty;
    const { BECOME_MEMBER } = LOYALTY_STATUS;
    const isLoyalty = selectedStatus === BECOME_MEMBER || !!(memberInfo && memberInfo.accountHolder);
    this.setState({ isSelectedExtra: true });
    const quantity = this.state.paxSelector ? this.state.guests : this.state.quantity;
    const data = {
      room_uuid: this.state.rooms[roomId - 1].unique_id,
      extra_code: extra.extra_code,
      avail_id: availId[roomId],
      days: this.formatDaysParam(),
      quantity,
      additional_data: this.formExtraFields(),
      category: extra.category,
      loyalty: isLoyalty,
    };
    this.props.dispatch(addSelectedExtrasToCart(data));
  }

  render() {
    const { extra, isMobile } = this.props;

    return (
      <CSSTransition
        in={this.state.animateRoom}
        timeout={500}
        classNames={{ enter: 'heartbeat room-tile' }}
        onExited={() => this.setState({ animateRoom: false })}
        key={extra.code}>
        {/* eslint-disable-next-line react/no-string-refs */}
        <form ref="Extra" className='extra-card card' onSubmit={this.formSubmit}>
          <PictureSlider photos={extra.photos} imageSize="sm" isMobile={isMobile} />
          <div className="extra-card__content flex-col">
            <div className="card-content flex-col">
              {this.renderExtraTitle(extra)}
              {this.renderExtraContent(extra)}
            </div>
            <div className="card-content flex-row justify-between mt-2 content-end">
              {this.renderExtraFields(extra)}
              {this.renderSelectButton(extra)}
            </div>
          </div>
        </form>
      </CSSTransition>
    );
  }
}

ExtraCard.propTypes = {
  extra: PropTypes.object.isRequired,
  roomId: PropTypes.string,
};

ExtraCard.defaultProps = {
  onShowRoomDetails: () => null,
};

ExtraCard.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isCartUpdating: state.cart.isUpdating,
  cart: state.cart,
  lang: state.i18nState.lang,
  checkIn: state.bookingFormState.checkIn,
  currency: state.booking.filterCurrency,
  availId: state.extras.extrasAvailId,
  isMobile: state.booking.device === DEVICES.MOBILE,
  loyalty: state.loyalty,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ExtraCard);
